import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/ModulesList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["msvcProxy"] */ "/usr/src/app/server/utils/clientSideProxy.ts");
